import { render, staticRenderFns } from "./HomePreview.vue?vue&type=template&id=358f7bee&scoped=true&"
import script from "./HomePreview.vue?vue&type=script&lang=js&"
export * from "./HomePreview.vue?vue&type=script&lang=js&"
import style0 from "./HomePreview.vue?vue&type=style&index=0&id=358f7bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f7bee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout,VProgressCircular})
